import { useCallback, useEffect, useState } from "react";

/** The redrive execution named by the page's `executionId` URL parameter. */
export const useSelectedExecution = () => {
  const [selectedExecutionId, setSelectedExecutionId] = useState<string | null>(
    null
  );

  // Keep selection in sync with the URL, including browser back/forward.
  useEffect(() => {
    const syncFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      setSelectedExecutionId(urlParams.get("executionId"));
    };
    syncFromUrl();
    window.addEventListener("popstate", syncFromUrl);
    return () => window.removeEventListener("popstate", syncFromUrl);
  }, []);

  const selectExecution = useCallback((executionId: string) => {
    setSelectedExecutionId(executionId);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("executionId", executionId);
    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
  }, []);

  // replaceState (not pushState) so browser back doesn't return to the execution.
  const clearSelection = useCallback(() => {
    setSelectedExecutionId(null);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("executionId");
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
  }, []);

  return {
    selectedExecutionId,
    setSelectedExecutionId,
    selectExecution,
    clearSelection,
  };
};
